export enum ContactTypes {
  WO_MANAGER = 'work_order_manager',
  VENDOR = 'vendor',
  CLIENT = 'client',
  TEAM_MEMBER = 'team_member',
  REGION_TEAM_MEMBER = 'region_team_member',
  CLIENT_CONTACT = 'client_contact',
  CLIENT_SITE_CONTACT = 'client_site_contact'
}
